module.exports = __webpack_public_path__ + "img/kt-knight-left.55df21b8.png";